export const terms = {
  slug: "terms",
  title: "Terms and Conditions",
  updated: "4 November 2026",
  sections: [
    {
      h: "1. About us and acceptance of these Terms",
      paras: [
        "1.1 The website www.solvedesk.space (the \"Website\") and the SolveDesk services are operated by Solve Desk Service Private Limited (CIN: U68100WR2026PTC296275), a company incorporated under the Companies Act, 2013, having its registered office at GRD FR, 1008 Laskarhat, Tagore Park, Tiljala, South 24 Parganas - 700039, West Bengal (\"SolveDesk\", \"we\", \"us\" or \"our\"). SolveDesk is a Solvelegalx.com initiative.",
        "1.2 These Terms and Conditions (\"Terms\") govern your use of the Website and your purchase of any SolveDesk service. By accessing the Website, submitting an enquiry, making a payment or signing an order form, you (\"Client\", \"you\" or \"your\") agree to be bound by these Terms, our Payment and Refund Policy and our Privacy Policy. If you do not agree, please do not use the Website or our services.",
        "1.3 Where you accept these Terms on behalf of a company, LLP, firm or other entity, you confirm that you are authorised to bind that entity.",
      ],
    },
    {
      h: "2. Eligibility",
      paras: [
        "2.1 You must be at least 18 years of age and competent to contract under the Indian Contract Act, 1872.",
        "2.2 Our services are intended for businesses, professionals and entities carrying on lawful activities in India.",
      ],
    },
    {
      h: "3. Our services",
      paras: ["3.1 SolveDesk offers the following services, as described on the Website or in your order form (together, the \"Services\"):"],
      items: [
        "Virtual office: use of a business address at a partner centre in Kolkata, Delhi, Bangalore, Pune, Hyderabad or other cities offered from time to time, for correspondence and, where the plan includes it, for registration as a registered office or principal place of business.",
        "Address documents: a document set for the chosen address, such as a no-objection certificate (NOC), rent or licence agreement and utility bill, as included in the plan.",
        "Mail handling and forwarding: receipt of letters and parcels at the address and notification or forwarding to you.",
        "Call answering: answering of calls on a business number on your behalf, where included.",
        "Meeting rooms: use of meeting rooms at partner centres on a pay-per-use basis, subject to availability.",
        "Business signage: display of your business name board at the address, where included.",
        "Coworking and dedicated desks: when offered, under a separate membership or dedicated desk agreement.",
        "Add-on services: GST registration support, GST return filing, and company, LLP or partnership registration, provided through Solvelegalx.com and its professionals.",
      ],
      parasAfter: [
        "3.2 The scope, duration and price of the Services you buy are as stated in the plan selected on the Website, the invoice or the order form. If there is a conflict, the signed order form or agreement prevails over these Terms.",
        "3.3 Address and meeting-room services are provided at centres owned or operated by our partners. We may change the centre, provided that the replacement is in the same city and of a similar standard, and we give you reasonable notice.",
      ],
    },
    {
      h: "4. Know Your Customer (KYC) and documents",
      paras: [
        "4.1 Before we issue any address documents, you must provide true, complete and current KYC documents, which may include identity and address proof of directors, partners or proprietors, PAN, certificate of incorporation, board resolution or authorisation letter, and any other document required by us, our partner centre or any government authority.",
        "4.2 We may refuse, suspend or terminate the Services if any document is false, incomplete or unverifiable, or if we reasonably believe that the Services are intended for an unlawful purpose.",
        "4.3 You must inform us within 7 days of any change in your name, constitution, directors, partners, contact details or business activity.",
      ],
    },
    {
      h: "5. Nature of the right granted",
      paras: [
        "5.1 The Services give you a limited, non-exclusive, non-transferable licence to use the address, and, where applicable, the facilities, for the purposes stated in your plan. No lease, tenancy, sub-tenancy or any interest in any immovable property is created in your favour.",
        "5.2 A virtual office plan does not give you a right to occupy any space, unless your plan expressly includes desk or office use.",
      ],
    },
    {
      h: "6. Permitted and prohibited use",
      paras: ["6.1 You may use the address only for lawful business correspondence and for the registrations expressly allowed in your plan.", "6.2 You shall not:"],
      items: [
        "use the address or Services for any unlawful, fraudulent or misleading purpose, including tax evasion, money laundering or impersonation;",
        "represent the address as your factory, warehouse or godown, or store goods there, unless agreed in writing;",
        "receive cash, hazardous, illegal or perishable items at the address;",
        "advertise the address in a way that suggests the partner centre or SolveDesk is your business or partner;",
        "sub-license, share or transfer the address or Services to any other person; or",
        "use the Website to upload malicious code, scrape data or interfere with its working.",
      ],
    },
    {
      h: "7. Government registrations and verification",
      paras: [
        "7.1 Registrations such as GST and company incorporation are granted by government authorities at their discretion. We provide documents and professional support only, and do not guarantee approval, timelines or the outcome of any application.",
        "7.2 You must cooperate with any physical verification, notice or query from a government authority relating to the address, and must respond to it within the time allowed. We may share information about you with authorities when required by law.",
        "7.3 You are solely responsible for your statutory filings, returns, tax payments and compliance with all laws applicable to your business.",
      ],
    },
    {
      h: "8. Mail handling",
      paras: [
        "8.1 We will notify you of mail received at the address by email or WhatsApp and forward or hold it as provided in your plan. Courier and postage charges for forwarding are payable by you unless included in the plan.",
        "8.2 We are not responsible for mail lost or delayed by a courier or postal service, or for the contents of any mail. We may refuse any item that appears unsafe or unlawful.",
        "8.3 Mail not collected or forwarded within 60 days may be returned to sender or destroyed after notice to you.",
      ],
    },
    {
      h: "9. Fees and taxes",
      paras: [
        "9.1 Fees are payable in advance as set out in our Payment and Refund Policy. All fees are exclusive of GST and other applicable taxes, which will be charged additionally.",
        "9.2 If fees remain unpaid after the due date, we may suspend the Services, including mail handling and the use of the address, after notice to you.",
      ],
    },
    {
      h: "10. Term, renewal and termination",
      paras: [
        "10.1 The Services run for the period stated in your plan and renew only if you pay the renewal fee before expiry.",
        "10.2 We may terminate the Services immediately by written notice if you breach these Terms, fail KYC, misuse the address, or if any authority directs us to do so.",
        "10.3 Either party may terminate for convenience by giving 30 days' written notice, subject to the Payment and Refund Policy.",
      ],
    },
    {
      h: "11. Effect of expiry or termination",
      paras: ["11.1 On expiry or termination:"],
      items: [
        "your right to use the address ends immediately;",
        "the NOC and any address documents issued to you stand withdrawn;",
        "you must, within 30 days, file the required forms to change your registered office, GST principal place of business and any other registration that uses the address, and send us proof; and",
        "you must remove the address from your website, letterheads, invoices and all other materials.",
      ],
      parasAfter: ["11.2 If you fail to do so, we may inform the relevant authorities that you no longer have the right to use the address, and charge a holding fee per month until the address is removed."],
    },
    {
      h: "12. Business signage",
      paras: ["12.1 Where signage is included, it will be displayed in the form and place permitted by the partner centre. The design and content must be approved by us, and must not infringe any third party's rights. Signage will be removed on expiry or termination."],
    },
    {
      h: "13. Limitation of liability",
      paras: [
        "13.1 We provide the Services with reasonable skill and care. To the fullest extent permitted by law, we are not liable for any indirect, consequential or special loss, loss of profit, business or data, or for any delay or refusal by any government authority.",
        "13.2 Our total liability arising out of or in connection with the Services shall not exceed the fees paid by you for the affected Service in the 3 months preceding the claim.",
      ],
    },
    {
      h: "14. Indemnity",
      paras: ["You shall indemnify and keep us, our partner centres and our officers harmless against all claims, penalties, losses and costs arising from your breach of these Terms, any false document, any unlawful use of the address, or any act of your business, employees or agents."],
    },
    {
      h: "15. Intellectual property",
      paras: ["The name SolveDesk, its logo, the Website and its content belong to us or our licensors. You may not use them without our prior written consent."],
    },
    {
      h: "16. Third-party links and services",
      paras: ["The Website may link to third-party websites and payment gateways. We are not responsible for their content, availability or practices, and your use of them is subject to their own terms."],
    },
    {
      h: "17. Force majeure",
      paras: ["We are not liable for any failure or delay caused by events beyond our reasonable control, including natural disasters, epidemics, government action, strikes, power or internet failure, or closure of a partner centre. We will try to provide an alternative address in the same city where possible."],
    },
    {
      h: "18. Governing law and disputes",
      paras: [
        "18.1 These Terms are governed by the laws of India.",
        "18.2 Any dispute shall first be referred to good-faith discussion for 30 days. If unresolved, it shall be referred to arbitration by a sole arbitrator appointed by mutual consent, under the Arbitration and Conciliation Act, 1996. The seat and venue of arbitration shall be Kolkata, and the language English.",
        "18.3 Subject to the arbitration clause, the courts at Kolkata shall have exclusive jurisdiction.",
      ],
    },
    {
      h: "19. Changes to these Terms",
      paras: ["We may update these Terms from time to time by publishing the revised version on the Website. Changes will not affect Services already paid for during the current term, except where required by law."],
    },
    {
      h: "20. Contact",
      paras: ["SolveDesk, Solve Desk Service Private Limited. Registered office: GRD FR, 1008 Laskarhat, Tagore Park, Tiljala, South 24 Parganas - 700039, West Bengal. Phone and WhatsApp: +91 62900 74471. Email: Legal@solvedesk.space. Booking queries: booking@solvedesk.space"],
    },
  ],
};
